customElements.get('quick-add-modal') ||
  customElements.define(
    'quick-add-modal',
    class extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        window.addEventListener('keyup', (e) => {
          if (e.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      hide(removeOpener = false) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);

        this.modalContent.innerHTML = '';
        if (removeOpener) this.openedBy = null;

        super.hide();
        setTimeout(() => this.remove(), 500);
      }

      show(button) {
        button.setAttribute('aria-disabled', true);
        button.classList.add('loading');

        const spinner = button.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.remove('hidden');

        fetch(button.getAttribute('data-product-url'))
          .then((res) => res.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            this.productElement = doc.querySelector('section[id^="MainProduct-"]');

            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML, button);

            if (window.Shopify?.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(button);
          })
          .finally(() => {
            button.removeAttribute('aria-disabled');
            button.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
            sliderQuickAddInit(this);
          });
      }

      setInnerHTML(container, html, button) {
        container.innerHTML = html;

        container.querySelectorAll('script').forEach((script) => {
          const newScript = document.createElement('script');
          Array.from(script.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
          newScript.appendChild(document.createTextNode(script.innerHTML));
          script.parentNode.replaceChild(newScript, script);
        });

        const title = document.createElement('h2');
        title.className = 'quick-add-modal__title h3';
        title.innerText = theme.quickAddTitle;
        container.querySelector('.product').prepend(title);

        const moreLink = document.createElement('a');
        moreLink.innerHTML = `<span>${theme.quickviewMore}</span>`;
        moreLink.href = button.getAttribute('data-product-url');
        moreLink.className = 'product__full-details button button--simple_secondary';

        const buttons = container.querySelector('.product-form__buttons');
        if (buttons) buttons.appendChild(moreLink);
      }

      removeDOMElements() {
        const selectorsToRemove = [
          '.product-popup',
          '.about',
          '.share-buttons',
          '.product__sku',
          '.breadcrumb',
          '.product-tags',
          '.pickup-availability',
          '.pickup-availability__overlay',
          'product-modal',
          '.product__description',
          '.product__inventory',
          '.product__media-sublist-outer',
        ];

        selectorsToRemove.forEach((selector) => {
          this.productElement.querySelectorAll(selector).forEach((el) => el.remove());
        });
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, 'quickadd-' + sectionId);

        this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((el) => {
          el.dataset.originalSection = sectionId;
        });
      }

      preventVariantURLSwitching() {
        const variantEl = this.modalContent.querySelector('variant-radios,variant-selects');
        if (variantEl) variantEl.setAttribute('data-update-url', 'false');
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        if (!product.classList.contains('product--columns')) return;

        const images = product.querySelectorAll('.product__media img');
        if (!images.length) return;

        let sizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        if (product.classList.contains('product--medium')) {
          sizes = sizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          sizes = sizes.replace('715px', '495px');
        }

        images.forEach((img) => img.setAttribute('sizes', sizes));
      }
    }
  );

customElements.get('quick-variant-selector') ||
  customElements.define(
    'quick-variant-selector',
    class QuickVariantSelector extends HTMLElement {
      constructor() {
        super();
        const card = this.closest('.card-horizontal-wrapper');
        const openBtn = card.querySelector('.quick-variant-button');
        this.openBtnText = card.querySelector('.quick-variant-button span');
        const closeBtn = this.querySelector('.close-modal');
        this.select = card.querySelector('select');
        this.image = card.querySelector('.card-horizontal__image img');

        this.priceContainer = card.querySelector('.price--product-button');
        this.addBtn = card.querySelector('button[type="submit"]');

        openBtn.addEventListener('click', () => this.classList.add('show'));
        closeBtn.addEventListener('click', () => this.classList.remove('show'));
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.variant-selector-modal, .quick-variant-button')) this.classList.remove('show');
        });

        this.options = this.querySelectorAll('.variant-option');

        this.options.forEach((opt) => {
          opt.addEventListener('click', () => this.OnSelectVariant(opt));
        });
      }

      OnSelectVariant(opt) {
        const id = opt.dataset.id;
        const price = opt.dataset.price;
        const compareAtPrice = opt.dataset.compareAtPrice;
        const img = opt.dataset.image;
        const title = opt.dataset.title;
        const available = opt.dataset.available === 'true';

        this.select.value = id;
        this.select.dispatchEvent(new Event('change', { bubbles: true }));

        if (img && this.image) {
          this.image.src = img;
        }

        if (this.priceContainer) {
          if (compareAtPrice && compareAtPrice > price) {
            if (this.priceContainer.classList.contains('can-toggle-sale')) {
              this.priceContainer.classList.add('price--on-sale');
            }
            this.priceContainer.querySelector('.price__sale .price-item--sale').innerHTML = price;
            this.priceContainer.querySelector('.price__sale .price-item--regular').innerHTML = compareAtPrice;
          } else {
            this.priceContainer.classList.remove('price--on-sale');
            this.priceContainer.querySelector('.price__regular .price-item--regular').innerHTML = price;
          }
        }

        this.addBtn.disabled = !available;
        this.addBtn.classList.toggle('disabled', !available);

        this.options.forEach((upd_opt) => {
          upd_opt.classList.toggle('current', upd_opt === opt);
        });

        this.openBtnText.textContent = title;
        this.classList.remove('show');
      }
    }
  );
